import { callGetApiv2 } from "./api";

// Mirrors api/loveForward.js's getLoveForwardChecks.
export async function getLoveForwardAutosends(customerId) {
  return callGetApiv2(`love-forward/admin/customers/${customerId}/autosends`);
}
